import React, { useEffect, useState } from "react";
import CustomModal from "../../components/CustomModal/CustomModal";
import TicketManagerForm from "../../components/Forms/TicketManagerForm/TicketManagerForm";
import useTicket from "../../hooks/useTicket";
import { useNavigate } from "react-router";
import { alertService } from "../../services/AlertService";
import UtilityService from "../../services/UtillityServices/UtilityService";
import CardLoadingPage from "../../components/CardLoadingPage/CardLoadingPage";
import useMediaQuery from '../../hooks/useMediaQuery';

export default function AreaPersonaleTicketPage() {
  const {
    getTicketsByParams,
    createTicket,
    modalStateTicket,
    setModalStateTicket,
    loadingStateTicket,
  } = useTicket();

  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [formCreateTicket, setFormCreateTicket] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const isMobile = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    setIsLoading(true);
    const fetchedTickets = await getTicketsByParams({ limite: 100, pagina: 1 });
    setTickets(fetchedTickets?.data ?? []);
    setIsLoading(false);
  };

  const handleCloseModal = () => {
    setModalStateTicket((state) => ({ ...state, showModalCreateTicket: false }));
    setFormCreateTicket({});
  };

  const openModalCreateTicket = () => {
    setModalStateTicket((state) => ({ ...state, showModalCreateTicket: true }));
  };

  const onCreateTicket = async () => {
    const requiredFields = ["oggetto", "descrizione", "id_classe"];
    const missingFields = UtilityService.validationForm(formCreateTicket, requiredFields);
    if (missingFields?.length > 0) {
      const formatFields = missingFields.map(field => field.replace("id_classe", "corso"));
      alertService.warn(`I seguenti campi sono obbligatori: ${formatFields.join(", ")}`, { autoClose: true });
      return;
    }
    const res = await createTicket(formCreateTicket);
    if (res) {
      fetchTickets();
      handleCloseModal();
    }
  };

  const cardStyle = {
    transition: 'all 0.3s ease-in-out',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  };

  const cardHoverStyle = {
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    transform: 'translateY(-2px)',
  };

  if (isLoading) {
    return <CardLoadingPage />;
  }

  return (
    <div className={`card custom-card w-100 shadow`}>
      <div className={`${isMobile ? 'p-3' : 'p-5'}`}>
        <div className='container' style={{minHeight: '700px'}}>
          <div className={`d-flex ${isMobile ? 'flex-column' : 'justify-content-between'} custom-card-header mb-4`}>
            <div className='d-flex gap-3'>
              <div className={`custom-icon-container`}>
                <i className={`bi custom-icon bi-ticket-perforated fs-2`}></i>
              </div>
              <div className='align-self-center'>
                <span className='fs-4 d-block'><i><b>I miei Ticket</b></i></span>
                <p className={`lead mb-0 ${isMobile ? 'd-none' : ''}`}>Gestisci le tue richieste di supporto e crea nuovi ticket</p>
              </div>
            </div>
            <div className={`align-self-center ${isMobile ? 'mt-3 mb-3' : ''}`}>
              <button className="btn btn-primary" onClick={openModalCreateTicket}>
                Nuovo Ticket
              </button>
            </div>
          </div>
          {isMobile && (
            <p className="lead mb-4">Gestisci le tue richieste di supporto e crea nuovi ticket</p>
          )}
          <div className='container'>
            <div className='row mt-4'>
              {tickets.length === 0 ? (
                <div className='my-5'>
                  <p>Nessun ticket da mostrare. Crea un nuovo ticket per iniziare.</p>
                </div>
              ) : (
                tickets.map((ticket) => (
                  <div key={ticket.id_ticket} className="col-md-6 col-lg-4 mb-4">
                    <div 
                      className="card h-100" 
                      style={cardStyle}
                      onMouseEnter={(e) => Object.assign(e.currentTarget.style, {...cardStyle, ...cardHoverStyle})}
                      onMouseLeave={(e) => Object.assign(e.currentTarget.style, cardStyle)}
                    >
                      <div className="card-body d-flex flex-column">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className={`badge ${ticket.stato === 'aperto' ? 'bg-success' : 'bg-danger'}`}>
                            {ticket.stato.charAt(0).toUpperCase() + ticket.stato.slice(1)}
                          </span>
                          <small className="text-muted">
                            {new Date(ticket.data_inserimento).toLocaleDateString()}
                          </small>
                        </div>
                        <h5 className="card-title mb-1">{ticket.oggetto}</h5>
                        <h6 className="card-subtitle mb-2 text-muted">
                          Corso: {ticket?.classe?.denominazione_corso}
                        </h6>
                        <p className="card-text flex-grow-1">{ticket.descrizione.substring(0, 100)}...</p>
                        <div className="mt-auto">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="badge bg-light text-dark">
                              <i className="bi bi-chat-dots me-1"></i>
                              {ticket.messaggi.length} risposte
                            </span>
                          </div>
                          {ticket.data_ultimo_messaggio && ticket.utente_ultimo_messaggio && (
                            <small className="text-muted d-block mb-2">
                              Ultima risposta: {ticket.utente_ultimo_messaggio.nome} {ticket.utente_ultimo_messaggio.cognome} il {new Date(ticket.data_ultimo_messaggio).toLocaleDateString()} alle {new Date(ticket.data_ultimo_messaggio).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                            </small>
                          )}
                          <button
                            className="btn btn-outline-primary w-100 mt-2"
                            onClick={() => navigate(`/ticket/${ticket.id_ticket}`)}
                          >
                            Vai al ticket
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={modalStateTicket.showModalCreateTicket}
        onHide={handleCloseModal}
        headerText="Crea nuovo ticket"
        size="lg"
        btnText="Crea ticket"
        body={
          <TicketManagerForm
            formTicketManager={formCreateTicket}
            setFormTicketManager={setFormCreateTicket}
            showModalTicketManager={modalStateTicket.showModalCreateTicket}
          />
        }
        closeButton={true}
        onUndoChanges={handleCloseModal}
        onSave={onCreateTicket}
        isLoading={loadingStateTicket.isLoadingTicketCreating}
      />
    </div>
  );
}
